import React, { Component } from 'react';
import FaPhone from 'react-icons/lib/fa/phone';
import FaEnvelope from 'react-icons/lib/fa/envelope';
import logo from './logo.png';

import Home from './Home';
import QuienesSomos from './QuienesSomos';
import SobreNosotros from './SobreNosotros';
import { Switch, Route } from 'react-router-dom'
import './App.css';

class App extends Component {
	render() {
		return (
			<div className="App">
				<header className="App-header" style={window.innerWidth < 768 ? null : {display: "flex"}}>
					<img src={logo} className="App-logo" alt="logo" />
					<div className={window.innerWidth < 768 ? "header-sm" : "header-right"}>
						<div style={window.innerWidth < 768 ? {marginRight: "20px", marginLeft: "10px"} : null }> <FaPhone /> +34 692 629 005 </div>
						<div> <FaEnvelope /> info@celtiaxxi.com </div>
					</div>
				</header>
				<Switch>
					<Route exact path='/' component={Home} />
					<Route path='/quienes-somos' component={QuienesSomos} />
					<Route path='/sobre-nosotros' component={SobreNosotros} />
				</Switch>
				<footer>
					<div>© 2018 Celtia XXI</div>
				</footer>
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js